import { useCallback } from 'react';
import type { Editor } from '@tiptap/react';

export function useEditorActions(editor: Editor | null) {
  const addLink = useCallback(() => {
    if (!editor) return;

    const previousUrl = editor.getAttributes('link').href;
    const url = window.prompt('Enter URL:', previousUrl);
    if (url === null) return;
    if (url === '') {
      editor.chain().focus().extendMarkRange('link').unsetLink().run();
      return;
    }
    editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
  }, [editor]);

  const addYoutubeVideo = useCallback(() => {
    if (!editor) return;

    const url = window.prompt('Enter YouTube URL:');
    if (url) {
      editor.commands.setYoutubeVideo({ src: url });
    }
  }, [editor]);

  const addImageFromUrl = useCallback(() => {
    if (!editor) return;

    const url = window.prompt('Enter image URL:');
    if (url) {
      const alt = window.prompt('Enter alt text for this image (optional):') || '';
      editor.chain().focus().setImage({ src: url, alt }).run();
    }
  }, [editor]);

  return {
    addLink,
    addYoutubeVideo,
    addImageFromUrl,
  };
}
